import { Box, TextField } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import SnackbarAlert from '../../components/SnackBar';
import { useWaits } from '../../hooks/UseWait';
import { useContext, useEffect, useState } from 'react';
import AuthContext from '../../context/AuthContext';
import Image1 from '../../images/paths/image1.png';
import Fetch from '../../services/Fetch';
import { useNavigate } from 'react-router-dom';
import MultipleSelectChip from '../../components/MultiSelect';
import useSnackBar from '../../hooks/UseSnackBar';
import { buildPathFormData } from '../../helper/PathFormData';
import { useConstants } from '../../hooks/UseConstants';
import { parsePaginatedResponse } from '../../utils/parsePaginatedResponse';
import FormSideImageLayout, { previewImageFile } from '../../components/FormSideImageLayout';
import PageContent from '../../components/PageContent';
import PageHero from '../../components/motion/PageHero';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

function CreatePath() {
     const { host, language } = useConstants();
     const { wait } = useContext(AuthContext);
     const { getWait, setGetWait, sendWait, setSendWait } = useWaits();
     const { openSnackBar, type, message, setSnackBar, setOpenSnackBar } = useSnackBar();
     const [courses, setCourses] = useState([]);
     const [categories, setCategories] = useState([]);
     const [categoryId, setCategoryId] = useState('');
     const [nameEn, setNameEn] = useState('');
     const [nameAr, setNameAr] = useState('');
     const [descriptionEn, setDescriptionEn] = useState('');
     const [descriptionAr, setDescriptionAr] = useState('');
     const [price, setPrice] = useState('');
     const [discountPrice, setDiscountPrice] = useState('');
     const [discountStartAt, setDiscountStartAt] = useState('');
     const [discountEndAt, setDiscountEndAt] = useState('');
     const [image, setImage] = useState('');
     const [selectedCourses, setSelectedCourses] = useState([]);
     const [option, setOption] = useState('');
     const navigate = useNavigate();

     const loadOptions = async (search, loadedOptions, { page }) => {
          const result = await Fetch(
               `${host}/categories?search=${encodeURIComponent(search || '')}&page=${page}&per_page=20`,
               'GET',
               null
          );
          const { items, pagination } = parsePaginatedResponse(result);
          setCategories(items);
          return {
               options: items.map(
                    item => ({ value: item.id, label: language === 'ar' ? item.name_ar : item.name_en })
               ),
               hasMore: pagination.current_page < pagination.last_page,
               additional: { page: page + 1 },
          };
     };

     const getCategories = async () => {
          const result = await Fetch(`${host}/categories?per_page=100`, 'GET', null);
          const { items } = parsePaginatedResponse(result);
          setCategories(items);
     };

     const getCourses = async () => {
          const result = await Fetch(`${host}/courses?teacher_id=${localStorage.getItem('id')}&per_page=100`);
          const { items } = parsePaginatedResponse(result);
          setCourses(items);
          setGetWait(false);
     };

     const createPath = async () => {
          setSendWait(true);
          const formData = buildPathFormData({
               nameEn, nameAr, descriptionEn, descriptionAr, price, image,
               discountPrice, discountStartAt, discountEndAt,
               categoryId, courses: selectedCourses,
          });
          let result = await Fetch(host + '/teacher/paths/store', 'POST', formData);
          if (result.status === 200) {
               navigate('/my-paths');
          } else if (result.status === 422) {
               setSnackBar('error', result.data.errors[0]);
          }
          setSendWait(false);
     };

     useEffect(() => {
          getCategories();
          getCourses();
     }, []);

     const fieldSx = { width: '100%' };

     return (
          <>
               <PageContent wait={wait} loading={getWait}>
                    <PageHero
                        title={language === 'ar' ? 'إنشاء مسار' : 'Create path'}
                        subtitle={language === 'ar' ? 'أضف مساراً تعليمياً جديداً' : 'Add a new learning path'}
                        icon={<AddCircleOutlineIcon />}
                    />
                    <Box sx={{ bgcolor: 'background.paper', boxShadow: 3, borderRadius: 3, overflow: 'hidden' }}>
                         <FormSideImageLayout
                              title={language === 'ar' ? 'إضافة مسار جديد' : 'Add New Path'}
                              illustrationSrc={Image1}
                              previewId="path-create-image"
                              uploadLabel={language === 'ar' ? 'صورة المسار' : 'Path cover'}
                              onImageChange={(e) => {
                                   previewImageFile(e, 'path-create-image');
                                   setImage(e.target.files[0]);
                              }}
                              onSubmit={createPath}
                              submitLabel={language === 'ar' ? 'إنشاء المسار' : 'Create'}
                              loading={sendWait}
                         >
                              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                                   <TextField sx={fieldSx} onChange={(e) => setNameEn(e.target.value)} label={language === 'ar' ? 'الاسم بالإنجليزية' : 'English Name'} variant="outlined" size="small" />
                                   <TextField sx={fieldSx} onChange={(e) => setNameAr(e.target.value)} label={language === 'ar' ? 'الاسم بالعربية' : 'Arabic Name'} variant="outlined" size="small" />
                              </Box>
                              <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                                   <TextField sx={fieldSx} onChange={(e) => setDescriptionEn(e.target.value)} label={language === 'ar' ? 'الوصف بالإنجليزية' : 'English Description'} multiline rows={3} variant="outlined" size="small" />
                                   <TextField sx={fieldSx} onChange={(e) => setDescriptionAr(e.target.value)} label={language === 'ar' ? 'الوصف بالعربية' : 'Arabic Description'} multiline rows={3} variant="outlined" size="small" />
                              </Box>
                              <Box sx={{ mt: 2 }}>
                                   <AsyncPaginate
                                        className="text-black"
                                        value={option}
                                        loadOptions={loadOptions}
                                        onChange={(opt) => { setOption(opt); setCategoryId(opt?.value); }}
                                        placeholder={language === 'ar' ? 'اختر التصنيف' : 'Select Category'}
                                        additional={{ page: 1 }}
                                   />
                              </Box>
                              <Box sx={{ mt: 2 }}>
                                   <MultipleSelectChip title={language === 'ar' ? 'الدورات' : 'Courses'} data={courses} onChange={setSelectedCourses} />
                              </Box>
                              <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                                   <TextField sx={fieldSx} type="number" onChange={(e) => setPrice(e.target.value)} label={language === 'ar' ? 'السعر' : 'Price'} variant="outlined" size="small" />
                                   <TextField sx={fieldSx} type="number" onChange={(e) => setDiscountPrice(e.target.value)} label={language === 'ar' ? 'سعر الخصم' : 'Discount Price'} variant="outlined" size="small" />
                              </Box>
                              <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                                   <TextField
                                        sx={fieldSx}
                                        type="date"
                                        onChange={(e) => setDiscountStartAt(e.target.value)}
                                        label={language === 'ar' ? 'بداية الخصم' : 'Discount starts'}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                   />
                                   <TextField
                                        sx={fieldSx}
                                        type="date"
                                        onChange={(e) => setDiscountEndAt(e.target.value)}
                                        label={language === 'ar' ? 'نهاية الخصم' : 'Discount ends'}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                   />
                              </Box>
                         </FormSideImageLayout>
                    </Box>
               </PageContent>
               <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
          </>
     );
}

export default CreatePath;
